import { z } from "zod";
import { SubmitHandler, useForm } from "react-hook-form";
import { zodResolver } from "@hookform/resolvers/zod";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import Cookies from "js-cookie";
import { toast } from "sonner";
import { AxiosError } from "axios";
import { format } from "date-fns";
// import { CalendarIcon } from "lucide-react";

import { Button } from "@/components/ui/button/button";
import {
  Form,
  FormControl,
  FormField,
  FormItem,
  FormLabel,
} from "@/components/ui/form/form";
import { Input } from "@/components/ui/input/input";
// import {
//   Popover,
//   PopoverContent,
//   PopoverTrigger,
// } from "@/components/ui/popover/popover";
import { createNewAttendanceRequest } from "@/config/mutation/employee";
// import { cn } from "@/lib/utils";
// import { Calendar } from "@/components/ui/calendar/calendar";

const formSchema = z.object({
  notes: z.string(),
  // date: z.date(),
});

type FormValues = z.infer<typeof formSchema>;

export const CreateAttendanceRequest = ({
  attId,
  handleClose,
  date,
}: {
  attId: string;
  date: string | Date;
  handleClose: () => void;
}) => {
  const empKey = Cookies.get("key") as string;
  const queryClient = useQueryClient();

  const form = useForm<FormValues>({
    resolver: zodResolver(formSchema),
    defaultValues: {
      notes: "",
      // date: undefined,
    },
  });

  const { mutate, isPending } = useMutation({
    mutationFn: createNewAttendanceRequest(empKey),
  });

  const onSubmit: SubmitHandler<FormValues> = (values: FormValues) => {
    // console.log(values);
    mutate(
      {
        date: new Date(date),
        notes: values?.notes,
        id: attId,
      },
      {
        onSuccess: async () => {
          await queryClient.invalidateQueries({
            queryKey: ["employee-attendance"],
          });
          toast.success("New Attendance Request Created!");
          handleClose();
        },
        onError: (error) => {
          console.log("ERROR WHILE CREATING NEW ATTENDANCE REQUEST", error);
          const isAxiosError = error instanceof AxiosError;
          if (isAxiosError) {
            const errorReason = error?.response?.data?.error as string;
            toast.error(errorReason);
          } else {
            toast.error(error?.message);
          }
        },
      }
    );
  };

  return (
    <div>
      <Form {...form}>
        <form onSubmit={form.handleSubmit(onSubmit)} className="space-y-3">
          <div className="space-y-5">
            <FormField
              name="notes"
              control={form.control}
              render={({ field }) => {
                return (
                  <FormItem>
                    <FormLabel>Note</FormLabel>
                    <FormControl>
                      <Input type="text" {...field} disabled={isPending} />
                    </FormControl>
                  </FormItem>
                );
              }}
            />

            {date && (
              <div>
                <span>Date: </span>
                <span>{format(new Date(date), "PPP")}</span>
              </div>
            )}

            {/* <FormField
              control={form.control}
              name="date"
              render={({ field }) => (
                <FormItem className="flex flex-col">
                  <FormLabel>Attendance date</FormLabel>
                  <Popover>
                    <PopoverTrigger asChild>
                      <FormControl>
                        <Button
                          type="button"
                          disabled={isPending}
                          variant={"outline"}
                          className={cn(
                            "w-[240px] pl-3 text-left font-normal",
                            !field.value && "text-muted-foreground"
                          )}
                        >
                          {field.value ? (
                            format(field.value, "PPP")
                          ) : (
                            <span>Pick a date</span>
                          )}
                          <CalendarIcon className="ml-auto h-4 w-4 opacity-50" />
                        </Button>
                      </FormControl>
                    </PopoverTrigger>
                    <PopoverContent className="w-auto p-0" align="start">
                      <Calendar
                        mode="single"
                        selected={field.value}
                        onSelect={field.onChange}

                      />
                    </PopoverContent>
                  </Popover>
                </FormItem>
              )}
            /> */}
          </div>

          <div className="flex items-center justify-end">
            <Button type="submit" disabled={isPending}>
              Request
            </Button>
          </div>
        </form>
      </Form>
    </div>
  );
};
